import { notifyToast } from 'utils/responseUtils'
import {
  GET_NEWS_FAILURE,
  GET_NEWS_SUCCESS,
  GET_PAGE_DATA_FAILURE,
  GET_PAGE_DATA_INITIAL,
  GET_PAGE_DATA_SUCCESS,
  NEWS_REQUESTED,
} from 'store/types/news.type'

export const getNewsDataAction =
  (urlArr = 'All', page = 1) =>
  async (dispatch) => {
    try {
      dispatch({ type: NEWS_REQUESTED })
      const response = await fetch(`/api/supabase/rss-feed?publisher=${urlArr}&page=${page}`)
      if (!response.ok) {
        throw new Error('Failed to fetch News')
      }
      const data = await response.json()
      dispatch({
        type: GET_NEWS_SUCCESS,
        payload: data || [],
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: GET_NEWS_FAILURE,
        payload: err || {
          error: 'failed to fetch News',
          message: 'faild to fetch',
        },
      })
    }
  }

export const getPaginatedData =
  (urlArr = 'All', page = 1) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_PAGE_DATA_INITIAL,
      })

      const response = await fetch(`/api/supabase/rss-feed?publisher=${urlArr}&page=${page}`)
      if (!response.ok) {
        throw new Error('Failed to fetch News')
      }

      const data = await response.json()

      dispatch({
        type: GET_PAGE_DATA_SUCCESS,
        payload: data || [],
      })

      // return data
    } catch (err) {
      console.log(err)
      dispatch({
        type: GET_PAGE_DATA_FAILURE,
        payload: err || {
          error: 'failed to fetch News',
          message: 'faild to fetch',
        },
      })
    }
  }

export const updateNewsCount = (newsId) => async (dispatch) => {
  try {
    const response = await fetch('/api/supabase/news-viewed', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ newsId: newsId }),
    })
    if (!response.ok) {
      throw new Error('Failed to get like the news')
    }
    const data = await response.json()
    return data
  } catch (err) {
    console.error('Error:', err.message)
    // throw err;
  }
}

export const getNewsSummary = async (content) => {
  try {
    const response = await fetch('/api/news/summarize-news', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ article: content }),
    })

    if (!response.ok) {
      throw new Error('Failed to get Summarize Content')
    }
    const data = await response.json()
    return data
  } catch (err) {
    console.error('Error:', err.message)
    throw err
  }
}

export const getNewsNarration = async (content) => {
  try {
    const response = await fetch('/api/news/narrate-news', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ input: content }),
    })

    if (!response.ok) {
      throw new Error('Failed to convert text to speech')
    }
    const audioBlob = await response.blob()
    const audioUrl = URL.createObjectURL(audioBlob)
    return audioUrl
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

export const getChangedSentiment = async (news, sentiment) => {
  try {
    const response = await fetch('/api/news/change-news-sentiment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ news: news, sentiment: sentiment }),
    })
    if (!response.ok) {
      throw new Error('Failed to change the sentiment')
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.log('Error:', error)
    throw error
  }
}

export const getChangedStyle = async (news, style) => {
  try {
    const response = await fetch('/api/news/change-style', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ news: news, style: style }),
    })
    if (!response.ok) {
      throw new Error('Failed to change the sentiment')
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.log('Error:', error)
    throw error
  }
}

export const fetchFullNewsContent = async (newsData, setSelectedNews, setLoading, setError) => {
  const { link, news_id } = newsData || {}
  try {
    const response = await fetch('/api/supabase/full-news-content', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ link: link, news_id: news_id }),
    })
    if (!response.ok) {
      setSelectedNews(newsData)
      throw new Error('Failed to get Full content')
    }
    const { data } = await response.json()

    if (data?.news_id) {
      setSelectedNews((prev) => ({ ...prev, ...data }))
    } else {
      setSelectedNews(newsData)
    }
    setLoading(false)
    setError(null)
  } catch (error) {
    setLoading(false)
  }
}

export const fetchNewsById =
  (id, setSelectedNews, setLoading, setError, setTotalLikes, user_id, setIsLiked, setIsBookmarked, setTotalBookmarks) =>
  async (dispatch) => {
    setLoading(true)
    setError(null)
    try {
      const response = await fetch(`/api/supabase/news-by-id?id=${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      if (!response.ok) {
        throw new Error('Failed to get Full content')
      }
      const data = await response.json()
      if (data) {
        console.log(data)
        if (user_id) {
          dispatch(fetchLikeBookmarkStatus(data?.news_id, user_id, setIsLiked, setIsBookmarked))
        }
        if (!data?.full_description) {
          await fetchFullNewsContent(data, setSelectedNews, setLoading, setError)
        } else {
          setSelectedNews(data)
          setTotalLikes(data?.total_likes || 0)
          setTotalBookmarks(data?.total_bookmarks || 0)
          setLoading(false)
          setError(null)
        }
      } else {
        setLoading(false)
        setError(null)
      }
      // return data
    } catch (error) {
      console.log(error)
      setLoading(false)
      setError(error)
    }
  }

export const fetchLikeBookmarkStatus = (news_id, user_id, setIsLiked, setIsBookmarked) => async (dispatch) => {
  try {
    const response = await fetch(`/api/supabase/news-likes/fetch-like-status?news_id=${news_id}&user_id=${user_id}`, {
      method: 'GET',
    })
    if (!response.ok) {
      throw new Error('Failed to fetch like and Bookmark status')
    }
    const data = await response.json()
    setIsLiked(data?.isLiked ?? false)
    setIsBookmarked(data?.isBookmarked ?? false)
  } catch (err) {
    console.error('Error:', err?.message)
    dispatch(notifyToast('error', err?.message || 'Failed to fetch like and Bookmark  status'))
  }
}

export const likeDislikeNews = (news_id, user_id, isLiked, setIsLiked, setTotalLikes) => async (dispatch) => {
  try {
    const response = await fetch('/api/supabase/news-likes/like-unlike-news', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ news_id, user_id }),
    })
    if (!response.ok) {
      throw new Error('Failed to get like the news')
    }
    const data = await response.json()
    if (data?.message) {
      dispatch(notifyToast('success', data?.message))
    }
    return data
  } catch (err) {
    console.error('Error:', err.message)
    // Revert optimistic UI update in case of error
    setIsLiked((prev) => !prev)
    setTotalLikes((prev) => prev + (isLiked ? -1 : 1))

    // throw err;
    dispatch(notifyToast('error', `failed to ${isLiked ? 'Unlike' : 'Like'} the news`))
  }
}

export const bookmarkNews =
  (news_id, user_id, isBookmarked, setIsBookmarked, setTotalBookmarks) => async (dispatch) => {
    try {
      const response = await fetch('/api/supabase/news-likes/bookmark-news', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ news_id, user_id }),
      })
      if (!response.ok) {
        throw new Error('Failed to Bookmark the news')
      }
      const data = await response.json()
      if (data?.message) {
        dispatch(notifyToast('success', data?.message))
      }
      return data
    } catch (err) {
      console.error('Error:', err.message)
      // Revert optimistic UI update in case of error
      setIsBookmarked((prev) => !prev)
      setTotalBookmarks((prev) => prev + (isBookmarked ? -1 : 1))

      // throw err;
      dispatch(notifyToast('error', `failed to ${isBookmarked ? 'remove Bookmark' : 'Bookmark the news'}`))
    }
  }
